import React, { useState } from "react";

import ContentHeader from "components/Layout/ContentHeader";
import Badge from "components/UI/Badge";
import Button from "components/UI/Button";
import { Input, Select } from "components/UI/Input";
import Modal from "components/UI/Modal";
import Table, { Column } from "components/UI/Table";
import "pages/AdminPage.scss";

interface Banner {
  id: string;
  title: string;
  position: "main_top" | "main_middle" | "category";
  linkUrl: string;
  isActive: boolean;
  order: number;
  startDate: string;
  endDate: string;
}

const POSITION_LABEL: Record<string, string> = {
  main_top: "메인 상단",
  main_middle: "메인 중단",
  category: "카테고리",
};

const MOCK: Banner[] = [
  {
    id: "1",
    title: "봄 신상품 기획전",
    position: "main_top",
    linkUrl: "/event/spring",
    isActive: true,
    order: 1,
    startDate: "2024-03-01",
    endDate: "2024-05-31",
  },
  {
    id: "2",
    title: "웨딩 필수템 모음",
    position: "main_top",
    linkUrl: "/collection/wedding",
    isActive: true,
    order: 2,
    startDate: "2024-01-01",
    endDate: "2024-12-31",
  },
  {
    id: "3",
    title: "주방용품 할인전",
    position: "main_middle",
    linkUrl: "/discount/kitchen",
    isActive: true,
    order: 1,
    startDate: "2024-03-15",
    endDate: "2024-04-15",
  },
  {
    id: "4",
    title: "인기 카테고리 배너",
    position: "category",
    linkUrl: "/category/popular",
    isActive: false,
    order: 1,
    startDate: "2024-02-01",
    endDate: "2024-02-28",
  },
];

const BannerSetting: React.FC = () => {
  const [showModal, setShowModal] = useState(false);

  const columns: Column<Banner>[] = [
    { key: "order", title: "순서", width: "60px" },
    { key: "title", title: "배너 제목" },
    {
      key: "position",
      title: "노출 위치",
      width: "130px",
      render: (v) => <Badge variant="info">{POSITION_LABEL[v]}</Badge>,
    },
    {
      key: "linkUrl",
      title: "링크 URL",
      width: "180px",
      render: (v) => <span style={{ fontSize: 12, color: "#6366F1" }}>{v}</span>,
    },
    {
      key: "startDate",
      title: "기간",
      width: "200px",
      render: (v, row) => `${v} ~ ${row.endDate}`,
    },
    {
      key: "isActive",
      title: "상태",
      width: "90px",
      render: (v) => <Badge variant={v ? "active" : "draft"}>{v ? "활성" : "비활성"}</Badge>,
    },
    {
      key: "actions",
      title: "관리",
      width: "80px",
      render: () => (
        <div style={{ display: "flex", gap: 6 }} onClick={(e) => e.stopPropagation()}>
          <Button size="sm" variant="ghost">
            삭제
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="admin-page">
      <ContentHeader
        title="광고 배너 설정"
        description="홈 화면 및 카테고리 배너를 관리합니다."
        actions={[
          <Button key="add" variant="primary" onClick={() => setShowModal(true)}>
            + 배너 추가
          </Button>,
        ]}
      />

      <div className="admin-page__card">
        <Table columns={columns} data={MOCK} rowKey="id" />
      </div>

      <Modal
        open={showModal}
        title="배너 추가"
        onClose={() => setShowModal(false)}
        width="460px"
        footer={
          <>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              취소
            </Button>
            <Button variant="primary" onClick={() => setShowModal(false)}>
              추가
            </Button>
          </>
        }
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <Input label="배너 제목" placeholder="배너 제목 입력" />
          <Select
            label="노출 위치"
            options={[
              { value: "main_top", label: "메인 상단" },
              { value: "main_middle", label: "메인 중단" },
              { value: "category", label: "카테고리" },
            ]}
          />
          <Input label="링크 URL" placeholder="/event/spring" />
          <div>
            <label style={{ display: "block", fontSize: 13, fontWeight: 500, marginBottom: 6 }}>배너 이미지</label>
            <div
              style={{
                border: "2px dashed #E4E4E7",
                borderRadius: 8,
                padding: "24px",
                textAlign: "center",
                cursor: "pointer",
                background: "#FAFAFA",
              }}
            >
              <div style={{ fontSize: 24, marginBottom: 8 }}>🖼️</div>
              <div style={{ fontSize: 13, color: "#71717A" }}>클릭하여 이미지 업로드</div>
              <div style={{ fontSize: 11, color: "#A1A1AA", marginTop: 4 }}>권장 사이즈: 1200 x 400px</div>
            </div>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <Input label="시작일" type="date" />
            <Input label="종료일" type="date" />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default BannerSetting;
